import * as summary from "./summary";

export const init = () => {
  document.getElementById('yourInfo').querySelectorAll('.form-control, .form-select').forEach(el => {
    el.addEventListener('input', summary.updateSummary);
  });
};